<template>
  <div class="laporan">
    <div>
      <h2>Setting</h2>

      <br />

      <div class="tab">
        <ul>
          <li>
            <a href="javascript:void(0)" class="active"> Toko </a>
          </li>
          <li>
            <a href="javascript:void(0)"> Profil </a>
          </li>
          <li>
            <a href="javascript:void(0)"> Password </a>
          </li>
        </ul>
      </div>

      <div class="grid">
        <div>
          <div class="card-border">
            <table>
              <tr>
                <td>Paket Berlangganan</td>
                <td>BASIC (150 transaksi / bulan)</td>
              </tr>
              <tr>
                <td>Jumlah transaksi bulan ini</td>
                <td>120</td>
              </tr>
              <tr>
                <td>Sisa transaksi</td>
                <td>30</td>
              </tr>
            </table>
          </div>
          <div class="card-border">
            <p>Upgrade Paket</p>
            <ul>
              <li
                v-for="(item, index) in paket"
                :key="index"
                :class="{ active: selected.nama == item.nama }"
                @click="selected = item"
              >
                <div>
                  {{ item.nama }}
                </div>
                <div>{{ item.jumlah }} transaksi / bulan</div>
              </li>
            </ul>

            <div class="action-upgrade" v-if="selected.harga">
              <h3>Rp {{ selected.harga | number }}</h3>
              <button type="button" class="btn-fill">Upgrade Sekarang</button>
            </div>
          </div>

          <form action="" v-if="false">
            <div class="form-group">
              <label>Logo</label>
            </div>
            <div class="form-group">
              <label>Nama Bisnis</label>
              <input type="text" />
            </div>
            <div class="form-group">
              <label>No Telp</label>
              <input type="tel" />
            </div>
            <div class="form-group">
              <label>Alamat</label>
              <textarea name="" id="" cols="30" rows="3"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" class="btn-fill">Simpan</button>
            </div>
          </form>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      paket: [
        {
          nama: "LITE",
          jumlah: "+150",
          harga: 50000,
        },
        {
          nama: "PREMIUM",
          jumlah: "+300",
          harga: 100000,
        },
        {
          nama: "UNLIMITED",
          jumlah: "Unlimited",
          harga: 150000,
        },
        {
          nama: "UNLIMITED 3 Bulan",
          jumlah: "Unlimited",
          harga: 450000,
        },
        {
          nama: "UNLIMITED 6 Bulan",
          jumlah: "Unlimited",
          harga: 900000,
        },
        {
          nama: "UNLIMITED 1 Tahun",
          jumlah: "Unlimited",
          harga: 1500000,
        },
      ],
      selected: {},
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .tab {
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;

      li {
        a {
          display: block;
          padding: 10px 20px;
          text-decoration: none;
          color: #333;
          text-transform: uppercase;
          &.active {
            color: var(--primary);
            border-bottom: 2px solid var(--primary);
          }
          &:hover {
            color: var(--primary);
          }
          &:active {
            background-color: #eee;
            border-bottom: 2px solid #eee;
          }
        }
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;

    form {
      width: 350px;
    }

    h3,
    p {
      margin: 0;
    }

    p {
      margin-bottom: 10px;
    }

    .card-border {
      border: 1px solid #ccc;
      padding: 15px;
      border-radius: 10px;
      margin-bottom: 15px;

      p {
        font-size: 15px;
        font-weight: 600;
      }

      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
          display: flex;
          justify-content: space-between;
          padding: 10px 0px;
          border-bottom: 1px solid #ccc;
          font-size: 15px;
          cursor: pointer;
          &:active,
          &.active {
            background-color: #eee;
          }
        }
      }

      .action-upgrade {
        h3 {
          margin: 20px 0px 10px;
        }
      }
    }

    table {
      tr {
        td {
          font-size: 15px;
          padding: 6px 0px;
          &:first-child {
            padding-right: 40px;
          }
          &:last-child {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue